import { render, staticRenderFns } from "./DataAccess.vue?vue&type=template&id=dcfd88fa&scoped=true"
import script from "./DataAccess.vue?vue&type=script&lang=js"
export * from "./DataAccess.vue?vue&type=script&lang=js"
import style0 from "./DataAccess.vue?vue&type=style&index=0&id=dcfd88fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfd88fa",
  null
  
)

export default component.exports